import React, { useEffect, useState } from "react";

// mui components
import { Box, IconButton, Stack } from "@mui/material";

// custom components
import CustomTable from "../../custom-table";
import MaskedInput from "../../custom-input/masked-input";
import CustomDivider from "../../custom-divider";
import Heading5 from "../../typography/heading-05";
import Body3 from "../../typography/body-03";

// mui icons
import { AddOutlined } from "@mui/icons-material";

// custom styles
import styles from "./index.module.scss";

const AssetsInformation = ({
	assetIndex,
	assetData,
	data,
	setData,
	handleDeleteVox,
	disabled,
}) => {
	const [assetRows, setAssetRows] = useState([]);
	const [total, setTotal] = useState("0");

	const assetInfoColumns = [
		{ id: "index", label: "", minWidth: 48 },
		{ id: "account-owner", label: "Account Owner", minWidth: 165 },
		{ id: "account-type", label: "Account Type", minWidth: 165 },
		{
			id: "financial-institution",
			label: "Financial Institution",
			minWidth: 310,
		},
		{ id: "account-number", label: "Account Number", minWidth: 310 },
		{ id: "cash-market-value", label: "Cash or Market value", minWidth: 200 },
	];

	const handleTotal = (totalData) => {
		const marketValueTotal = totalData.reduce(
			(sum, obj) =>
				sum + (parseFloat(obj.urla2020CashOrMarketValueAmount) || 0),
			0
		);

		setTotal(marketValueTotal.toString());
	};

	console.log("55 total:", total);

	useEffect(() => {
		if (assetData !== undefined) {
			setAssetRows(assetData);
			handleTotal(assetData);
		}
	}, [assetData]);

	const handleAddRow = () => {
		setData(
			data.map((item, index) => {
				if (assetIndex === index) {
					return [
						...item,
						{
							isVod: true,
							vodIndex:
								assetData === undefined || assetData?.length === 0
									? 1
									: assetData[assetData?.length - 1]?.vodIndex + 1,
						},
					];
				} else {
					return item;
				}
			})
		);
	};

	const handleDeleteTempRow = (rowIndex, vodIndex) => {
		setData(
			data.map((item, index) => {
				if (assetIndex === index) {
					return assetData
						?.filter((row, i) => rowIndex !== i)
						.map((row) =>
							row.vodIndex > vodIndex
								? { ...row, vodIndex: row.vodIndex - 1 }
								: row
						);
				} else {
					return item;
				}
			})
		);
	};

	const handleDeleteRow = (rowIndex, vodIndex, row) => {
		console.log("115 row:", row);

		if (row?.id) {
			handleDeleteVox(rowIndex, row?.altId, "vods", "asset");
		} else {
			handleDeleteTempRow(rowIndex, vodIndex);
		}
	};

	const handleChangeRow = (rowIndex, field, value) => {
		console.log("63 row:", rowIndex, field, value);

		setAssetRows(() =>
			assetRows?.map((obj, i) => {
				if (i === rowIndex) {
					return { ...obj, [field]: value };
				}

				return obj;
			})
		);

		setData(
			data.map((data, index) => {
				if (assetIndex === index) {
					let updatedData = assetData?.map((obj, i) => {
						if (i === rowIndex) {
							return { ...obj, [field]: value };
						}
						return obj;
					});
					return updatedData;
				} else {
					return data;
				}
			})
		);
	};

	return (
		<Box className={styles.cardContainer}>
			<Stack direction="column" className={styles.cardHeaderContainer}>
				<Heading5 text="Assets" fontType="semibold" />

				<Body3 text="Provide details about the assets" />
			</Stack>
			<Stack direction="column" className={styles.formSectionContainer}>
				<Stack direction="row" className={styles.inputSectionContainer}>
					{/* asset information table  */}
					<CustomTable
						tableType="asset-information"
						columnData={assetInfoColumns}
						rowData={assetRows}
						handleRemoveRow={handleDeleteRow}
						handleUpdate={handleChangeRow}
						disableRow={disabled}
					/>

					<Box className={styles.addIconContainer}>
						<IconButton
							id="add-asset-btn"
							className={styles.addIconBtn}
							onClick={() => handleAddRow()}
							disabled={disabled || assetRows?.length >= 25}
						>
							<AddOutlined className={styles.addIcon} />
						</IconButton>
					</Box>

					<Stack className={styles.totalContainer}>
						<Body3 text="Assets total" extraClass={styles.totalText} />
						<MaskedInput
							placeholder="$"
							type="currency"
							value={total}
							onInputChange={(value) => console.log("315 value:", value)}
							disabled={true}
						/>
					</Stack>
				</Stack>
			</Stack>

			<CustomDivider />
		</Box>
	);
};

export default AssetsInformation;
